import { useMemo } from "react";
import { Icon, Panel, Skeleton, Typography } from "@/components/atoms";
import { AssetUpload } from "@/components/organisms";
import { useGetAssetsQuery } from "@/redux/apis/config/asset";
import { useAppSelector } from "@/redux/hooks";
import { operatorBrandingSelector } from "@/redux/slices/marketing/selectors";
import { clsx } from "@/utils";

export const OperatorBrandingPanel = () => {
  const { isFetching } = useGetAssetsQuery();
  const { assets } = useAppSelector(operatorBrandingSelector);
  const images = useMemo(() => {
    const res = assets.reduce((prev, curr) => {
      const { path, type } = curr;
      prev[type] = path;
      return prev;
    }, {} as Record<string, string>);
    return res;
  }, [assets]);

  if (isFetching) return <Skeleton />;

  return (
    <Panel className="flex flex-1 flex-col">
      <Typography variant="h3">Operator Branding</Typography>
      <div className="mt-5 flex flex-col gap-x-[72px] gap-y-10 lg:flex-row">
        <div className="flex max-w-[405px] flex-col">
          <div className="flex flex-row items-center gap-x-1.5">
            <Typography variant="action" className={clsx({ "text-danger": !images.logo })}>
              Company Logo
            </Typography>
            {!images.logo && <Icon name="InfoCircle" variant="Bold" className="text-danger" />}
          </div>
          <Typography variant="paragraph" className="mt-2 text-neutral-dark-gray">
            Ensure your logo looks its best in communications and invoices. Recommended size: 150x50 px.
          </Typography>
          <Typography variant="small" className="mt-1 text-neutral-dark-gray">
            PNG & JPG supported
          </Typography>
          <AssetUpload path={images.logo} type="logo" className="mt-4" />
        </div>
        <div className="flex max-w-[405px] flex-col">
          <div className="flex flex-row items-center gap-x-1.5">
            <Typography variant="action" className={clsx({ "text-danger": !images.emblem })}>
              Emblem
            </Typography>
            {!images.emblem && <Icon name="InfoCircle" variant="Bold" className="text-danger" />}
          </div>
          <Typography variant="paragraph" className="mt-2 text-neutral-dark-gray">
            Display your emblem clearly across the platform. Recommended size: 256x256 px.
          </Typography>
          <Typography variant="small" className="mt-1 text-neutral-dark-gray">
            PNG & JPG supported
          </Typography>
          <AssetUpload path={images.emblem} type="emblem" className="mt-4" />
        </div>
      </div>
    </Panel>
  );
};
